import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import LoginForm from '@src/components/forms/login.form';

import { useAuth } from '@contexts/authContext';

import bgLogin from '../../assets/images/bg_login.svg';

export default function LoginPage() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const sessionExpired = localStorage.getItem('SESSION_EXPIRED') === 'true';
    const __error = localStorage.getItem('__error');

    if (sessionExpired) {
      localStorage.removeItem('SESSION_EXPIRED');
      localStorage.removeItem('__error');
      if (__error) sessionStorage.setItem('__error', __error);
      toast.error(
        'Your session has expired. Please log in again. [401 Unauthorized]',
        {
          position: 'top-center',
          autoClose: 3700,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        },
      );
    }

    if (auth.isAuthenticated !== null && auth.isAuthenticated) {
      navigate('/verify-code');
    }
  }, [auth, navigate]);
  return (
    <main className='font-poppins flex items-center justify-center overflow-hidden bg-[#F7FBFF]'>
      <aside
        className='h-screen w-1/2 bg-cover bg-bottom'
        style={{
          backgroundImage: `url(${bgLogin})`,
        }}
      >
        {/* <div className="flex justify-center">
          <img
            src="/logo.svg"
            alt="logo"
            className="flex justify-center px-16 fixed top-10 left-10 w-48"
          />
        </div> */}
      </aside>
      <aside className='h-full w-1/2'>
        <div className='px-20'>
          <h1 className='font-poppins mb-10 font-bold'>Login</h1>
          <LoginForm />
        </div>
      </aside>
    </main>
  );
}
